import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'motion/react';
import { ReactElement } from 'react';
import { RedisArtworkReaction } from '../../API';
import { useReactions } from '../../hooks/HostSessionControlHooks';
import { reactionImageForType, ReactionType, reactionTypeForNumber } from '../../utils/reactions';

const DEFAULT_LIMIT = 10;

export interface Reaction {
  playerId: string;
  playerCardId: string;
  reactionType: ReactionType;
  displayed?: boolean;
}

export const reactionForArtworkReaction = (artworkReaction: RedisArtworkReaction) => {
  const reactionType = reactionTypeForNumber(artworkReaction.reaction);
  return {
    playerId: artworkReaction.playerId,
    playerCardId: artworkReaction.playerCardId,
    reactionType,
    displayed: false
  };
};

const ReactionsBar = ({ limit = DEFAULT_LIMIT }: { limit?: number }): ReactElement => {
  const reactions = useReactions();
  const displayedReactions = reactions.slice(-limit).reverse();
  const showMore = reactions.length > limit;

  return (
    <div className="flex flex-col">
      <AnimatePresence>
        {displayedReactions.length > 0 && (
          <motion.h3
            className="font-bold"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            Session Badges
          </motion.h3>
        )}
      </AnimatePresence>
      <div className="flex flex-row space-x-4 items-center">
        {showMore && (
          <FontAwesomeIcon icon={faEllipsis} className="text-[#D51668] w-24 h-24 pr-4" />
        )}
        <div className="flex flex-row space-x-4">
          {displayedReactions.map((reaction) => (
            <motion.img
              src={reactionImageForType(reaction.reactionType)}
              initial={{ opacity: 0, scale: 0, y: 50 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              key={`reaction-${reaction.playerCardId}-${reaction.playerId}-$${reaction.reactionType}`}
              className="w-32 h-32"
              id={`reaction-${reaction.playerCardId}-${reaction.playerId}-$${reaction.reactionType}`}
              alt={`Reaction ${reaction.reactionType}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactionsBar;
